import React from 'react';
import { EyeIcon, EditIcon, TrashIcon, GlobeIcon, CoinsIcon, FileTextIcon } from 'lucide-react';
export function CountryList({
  countries,
  onSelectCountry,
  onDeleteCountry,
  locale
}) {
  // Group countries by region for better organization
  const countryByRegion = countries.reduce((acc, country) => {
    if (!acc[country.region]) {
      acc[country.region] = [];
    }
    acc[country.region].push(country);
    return acc;
  }, {});
  // Sort regions alphabetically
  const sortedRegions = Object.keys(countryByRegion).sort();
  return <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-16924">
      {countries.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-16925">
          No countries found. Add a new country to get started.
        </div> : <>
          {sortedRegions.map(region => <div key={region} className="border-b border-gray-200 last:border-b-0" data-id="element-16926">
              <div className="bg-gray-50 px-4 py-2" data-id="element-16927">
                <h3 className="text-sm font-medium text-gray-700" data-id="element-16928">{region}</h3>
              </div>
              <ul className="divide-y divide-gray-200" data-id="element-16929">
                {countryByRegion[region].sort((a, b) => {
            const nameA = a.commonName || a.name || '';
            const nameB = b.commonName || b.name || '';
            return nameA.localeCompare(nameB);
          }).map(country => {
            const displayName = country.commonName || country.name || 'Unknown';
            const hasOfficialName = country.officialName && country.officialName !== displayName;
            return <li key={country.alpha2Code} data-id="element-16930">
                        <div className="px-4 py-4 flex items-center justify-between hover:bg-gray-50 cursor-pointer transition-colors" onClick={() => onSelectCountry(country)} data-id="element-16931">
                          <div className="flex-1" data-id="element-16932">
                            <div className="flex items-center" data-id="element-16933">
                              <div className="min-w-0 flex-1" data-id="element-16934">
                                <div className="flex items-center" data-id="element-16935">
                                  <p className="text-sm font-medium text-indigo-600 truncate" data-id="element-16936">
                                    {displayName}
                                  </p>
                                  <p className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-16937">
                                    {country.alpha2Code}
                                  </p>
                                  <p className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-16938">
                                    {country.alpha3Code}
                                  </p>
                                </div>

                                {hasOfficialName && <div className="mt-1 flex items-center text-xs text-gray-600" data-id="element-16939">
                                    <FileTextIcon className="flex-shrink-0 mr-1.5 h-3 w-3 text-gray-400" data-id="element-16940" />
                                    <span className="italic" data-id="element-16941">
                                      Official: {country.officialName}
                                    </span>
                                  </div>}

                                <div className="mt-2 flex items-center text-sm text-gray-500" data-id="element-16942">
                                  <div className="flex items-center mr-4" data-id="element-16943">
                                    <GlobeIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" data-id="element-16944" />
                                    <span data-id="element-16945">{country.subRegion}</span>
                                  </div>
                                  <div className="flex items-center mr-4" data-id="element-16946">
                                    <CoinsIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" data-id="element-16947" />
                                    <span data-id="element-16948">{country.officialCurrency}</span>
                                  </div>
                                  <div className="flex items-center" data-id="element-16949">
                                    <span className="text-gray-400 mr-1" data-id="element-16950">
                                      Phone:
                                    </span>
                                    <span data-id="element-16951">{country.phoneCode}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="ml-4 flex-shrink-0 flex space-x-2" data-id="element-16952">
                            <button type="button" onClick={e => {
                    e.stopPropagation();
                    onSelectCountry(country);
                  }} className="text-green-600 hover:text-green-900" title="View country" data-id="element-16953">
                              <EyeIcon className="h-4 w-4" data-id="element-16954" />
                              <span className="sr-only" data-id="element-16955">View</span>
                            </button>
                            <button type="button" onClick={e => {
                    e.stopPropagation();
                    onSelectCountry(country);
                  }} className="text-indigo-600 hover:text-indigo-900" title="Edit country" data-id="element-16956">
                              <EditIcon className="h-4 w-4" data-id="element-16957" />
                              <span className="sr-only" data-id="element-16958">Edit</span>
                            </button>
                            <button type="button" onClick={e => {
                    e.stopPropagation();
                    onDeleteCountry(country);
                  }} className="text-red-600 hover:text-red-900" title="Delete country" data-id="element-16959">
                              <TrashIcon className="h-4 w-4" data-id="element-16960" />
                              <span className="sr-only" data-id="element-16961">Delete</span>
                            </button>
                          </div>
                        </div>
                      </li>;
          })}
              </ul>
            </div>)}
        </>}
    </div>;
}